// ==========================================================================
// Dropdown
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

import {
    toggleAttributeValue,
    removeAttributeValue
} from 'groots/utilities';

// TODO: slide direction; calculate if the option list has enough space to
// expand bewteen end of viewport and dropdown
class GrDropdown {
    constructor(selector, options) {
        this.pluginName = 'grDropdown';

        this.default = {
            trigger: '[gr-dropdown-trigger]',
            target: '[gr-dropdown-target]',
        };

        // Merge defaults with user's settings
        this.config = {
            ...this.default,
            ...options,
        };

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Get elements
        this.trigger = this.selector.querySelector(this.config.trigger);
        this.target = this.selector.querySelector(this.config.target);

        // Retrieve plugin custom parameters
        this.params = this.selector.getAttribute('gr-dropdown').split(' ');

        this.init();
    }

    //  Methods
    // ----------------------------------------------------------------------

    init() {
        if (this.selector === null) {
            throw new Error(this.pluginName + ': fail - something wrong with your selector');
        } else {
            // ready
            this.ready = true;

            toggleAttributeValue(this.selector, 'gr-dropdown', 'ready');

            if (window.window.groots.verbose) {
                console.warn(this.pluginName + ': ready');
            }

            // binding
            const arr = [
                'handleClick',
                'handleDocumentClick',
                'handleMouseEnter',
                'handleMouseLeave',
                'handleAnimationEnd',
                'handleAnimationStart',
            ];

            for (let index = 0; index < arr.length; index++) {
                const method = arr[index];
                this[method] = this[method].bind(this);

            }

            // addEventListener
            if ('ontouchstart' in document === false && this.params.includes('hover')) {
                this.selector.addEventListener('mouseenter', this.handleMouseEnter);
                this.selector.addEventListener('mouseleave', this.handleMouseLeave);
            } else {
                this.trigger.addEventListener('click', this.handleClick);
                document.addEventListener('click', this.handleDocumentClick);
            }

            this.target.addEventListener('animationstart', this.handleAnimationStart);
            this.target.addEventListener('animationend', this.handleAnimationEnd);
        }
    }

    // Destroy - remove listeners to prevent from memory leak
    destroy() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ': destroyed');
        }

        removeAttributeValue(this.selector, 'gr-dropdown', 'ready active');

        if ('ontouchstart' in document === false && this.params.includes('hover')) {
            this.selector.removeEventListener('mouseenter', this.handleMouseEnter);
            this.selector.removeEventListener('mouseleave', this.handleMouseLeave);
        } else {
            this.trigger.removeEventListener('click', this.handleClick);
            document.removeEventListener('click', this.handleDocumentClick);
        }

        this.target.removeEventListener('animationstart', this.handleAnimationStart);
        this.target.removeEventListener('animationend', this.handleAnimationEnd);
    }

    moveTarget() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' moveTarget');
        }

        this.params = this.selector.getAttribute('gr-dropdown').split(' ');
        this.isOpen = this.params.includes('active') ? false : true;
        toggleAttributeValue(this.selector, 'gr-dropdown', 'active', true);

        if (this.isOpen) {
            removeAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
            toggleAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
        } else {
            removeAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
            toggleAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
        }
    }

    handleAnimationStart() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' animation start');
        }

        toggleAttributeValue(this.selector, 'gr-dropdown', 'animating');
    }

    handleAnimationEnd() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' animation end');
        }

        removeAttributeValue(this.selector, 'gr-dropdown', 'animating');
        removeAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
        removeAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
    }

    handleClick() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' click');
        }

        this.moveTarget();
    }

    handleMouseEnter() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' mouseenter');
        }

        this.moveTarget();
    }

    handleMouseLeave() {
        if (window.groots.verbose) {
            console.warn(this.pluginName + ' mouseleave');
        }

        this.moveTarget();
    }

    handleDocumentClick(event) {
        this.params = this.selector.getAttribute('gr-dropdown').split(' ');

        if (!event.target.closest('[gr-dropdown]') && this.params.includes('active')) {
            if (window.groots.verbose) {
                console.warn('here');
                console.warn(this.pluginName + ' clicked outside');
            }

            this.moveTarget();
        }
    }
}

export default GrDropdown;

//  Auto-Instantiation
// ----------------------------------------------------------------------

(function() {
    const all = document.querySelectorAll('[gr-dropdown]');
    window.groots.plugins.grDropdown = {};

    if (all.length) {
        window.groots.plugins.grDropdown.instances = {};
        let index = -1;

        while (all[++index]) {
            window.groots.plugins.grDropdown.instances[index] = new GrDropdown(all[index]);
        }
    }
}());
